<template>
<div class="chapter">
<div class="inner_page">
<div class="backcolor1">
<p class="dedication">To Albert,<br/>With all my love,<br/>—Laurie</p>
<p class="dedicationa">For little Juliette, my fashion princess<br/>and best shopping buddy<br/>—J.K.</p>
<p class="imgcenter"><img alt="Image" src="images/2.jpg"/></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// dedication.vue?e3f75f92